import { PlusIcon } from "@heroicons/react/24/outline";
import { defaultLinkStyle } from "components/ui/link";
import { PrimaryButton } from "components/ui/primary-button";
import { SecondaryButton } from "components/ui/secondary-button";
import { TextArea } from "components/ui/textarea";
import React, { useState } from "react";

interface TaskDoneNoteProps {
    notes: string | null | undefined;
    onSaveNote: (notes: string) => Promise<void>;
}

export const TaskDoneNote: React.FC<TaskDoneNoteProps> = ({ notes, onSaveNote }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [draft, setDraft] = useState(notes ?? "");
    const [isSaving, setIsSaving] = useState(false);

    const startEditing = () => {
        setDraft(notes ?? "");
        setIsEditing(true);
    };

    const save = async () => {
        setIsSaving(true);
        await onSaveNote(draft.trim());
        setIsSaving(false);
        setIsEditing(false);
    };

    if (isEditing) {
        return (
            <div className="space-y-2">
                <TextArea
                    label="Note"
                    autoFocus
                    autoGrow
                    value={draft}
                    onChange={e => setDraft(e.target.value)}
                />
                <div className="flex gap-2">
                    <PrimaryButton onClick={save} disabled={isSaving}>
                        Save
                    </PrimaryButton>
                    <SecondaryButton onClick={() => setIsEditing(false)}>
                        Cancel
                    </SecondaryButton>
                </div>
            </div>
        );
    }

    if (notes) {
        return (
            <div className="flex items-start space-x-2 text-sm text-gray-600">
                <span className="whitespace-pre-line">
                    <span className="font-medium">Notes:</span> {notes}
                </span>
                <button onClick={startEditing} className={defaultLinkStyle}>
                    Edit note
                </button>
            </div>
        );
    }

    return (
        <button onClick={startEditing} className={defaultLinkStyle}>
            <div className="flex items-center space-x-1">
                <PlusIcon className="w-5 h-5" />
                <span className="text-sm">Add note</span>
            </div>
        </button>
    );
};
